import { RequirementsList } from "@certn/cascadia-react";
import { RequirementsItem } from "@certn/cascadia-react/components/requirements-list/types";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useMemo } from "react";

import { FieldType } from "../fields/types";
import { getRule } from "../validationRules";

type SectionRequirementsListProps = {
  fields: FieldType<components["schemas"]["SectionField"]>[];
  values: Record<string, unknown>;
  errors: Record<string, unknown>;
};

export function SectionRequirementsList({
  fields,
  values,
  errors,
}: SectionRequirementsListProps) {
  const requirementsList = useMemo(
    () =>
      fields.reduce((result: RequirementsItem[], current) => {
        current.field.validation_rules.forEach((validationRule) => {
          const rule = getRule(validationRule);

          if (!rule || !validationRule.display_text) return;

          let style: "normal" | "success" | "error" = "normal";
          const fieldValue = values[current.field.name];
          const isValid = rule?.isValid(fieldValue);

          if (errors[validationRule.type]) {
            style = "error";
          } else if (fieldValue && isValid) {
            style = "success";
          }

          result.push({
            text: validationRule.display_text,
            style,
          });
        });
        return result;
      }, []),
    [fields, errors, values]
  );

  return <RequirementsList requirementsList={requirementsList} />;
}
